require('./bootstrap');

// Components
require('./components/animation');
require('./components/disclaimer');
require('./components/colorbox');
require('./components/post');
require('./components/scrollTracker');
require('./components/selectric');
require('./components/teamFilters');
require('./components/utilities');

// Blocks
require('./blocks/accordion');
require('./blocks/content-box');
require('./blocks/strategy');
require('./blocks/locations');
require('./blocks/people');
require('./blocks/responsive-slider');
require('./blocks/stats');
require('./blocks/tabs');
require('./blocks/timeline');
require('./blocks/wp-menu');
